<template>
  <svg
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 339.498 143.859"
    enable-background="new 0 0 339.498 143.859"
  >
<g>
    <path fill="#FFFFFF" d="M53.733,55.083C43.338,42.063,24.359,39.936,11.35,50.33c-13.026,10.4-15.149,29.382-4.762,42.392
      c2.818,3.526,59.021,47.613,59.021,47.613c5.164,4.477,12.952,4.791,18.491,0.366c5.532-4.421,6.948-12.072,3.718-18.116
      l0.197-0.148C88.015,122.437,56.372,58.39,53.733,55.083"/>
    <path fill="#FFFFFF" d="M147.934,23.58c-3.643-16.255-19.763-26.482-36.018-22.846c-16.26,3.635-26.485,19.764-22.857,36.018
      c0.996,4.412,32.178,68.664,32.178,68.664c2.683,6.292,9.54,9.979,16.453,8.437c6.914-1.546,11.54-7.811,11.288-14.647l0.248-0.045
      C149.225,99.157,148.859,27.72,147.934,23.58"/>
    <path fill="#FFFFFF" d="M247.823,37.409c3.857-16.209-6.146-32.461-22.357-36.334c-16.199-3.851-32.469,6.156-36.32,22.373
      c-1.055,4.386-1.189,75.812-1.189,75.812c-0.344,6.839,4.205,13.151,11.092,14.784c6.896,1.647,13.797-1.943,16.564-8.203
      l0.25,0.062C215.861,105.902,246.843,41.521,247.823,37.409"/>
    <path fill="#FFFFFF" d="M332.642,92.83c10.58-12.87,8.705-31.88-4.178-42.452c-12.863-10.571-31.871-8.692-42.441,4.175
      c-2.863,3.484-34.291,67.622-34.291,67.622c-3.312,5.978-2,13.66,3.482,18.158c5.469,4.495,13.25,4.298,18.484-0.122l0.195,0.163
      C273.898,140.374,329.952,96.099,332.642,92.83"/>
</g>
</svg>
</template>

<script>
export default {
  name: 'llagrimes'
}
</script>

<style lang="scss" scoped>
  .st0 { fill: #FFFFFF; }
  .st1 { fill: url(#compromisGradient); }
  .st2 { fill: url(#feministaGradient); }
  .st3 { clip-path:url(#SVGID_4_); }
  .st4 { fill: #EF404D; }
  .st5 { fill: #F79226; }
  .st6 { fill: #FFD10F; }
  .st7 { fill: #7FC347; }
  .st8 { fill: #55A4DB; }
  .st9 { fill: #A14A9C; }
  .st10 { fill:url(#SVGID_5_); }
  .st11 { fill:url(#SVGID_6_); }
  .st12 { clip-path:url(#SVGID_8_); }
</style>
